var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsObjectiveGolive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10505_56299)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#F9ED33",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 37.5404H22.4997C16.1647 37.5404 13.458 34.8337 13.458 28.4987V21.4987C13.458 15.1637 16.1647 12.457 22.4997 12.457H29.4997C35.8347 12.457 38.5413 15.1637 38.5413 21.4987V28.4987C38.5413 34.8337 35.8347 37.5404 29.4997 37.5404ZM22.4997 14.207C17.1213 14.207 15.208 16.1204 15.208 21.4987V28.4987C15.208 33.877 17.1213 35.7904 22.4997 35.7904H29.4997C34.878 35.7904 36.7913 33.877 36.7913 28.4987V21.4987C36.7913 16.1204 34.878 14.207 29.4997 14.207H22.4997Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0604 20.1719H14.9404C14.4621 20.1719 14.0654 19.7752 14.0654 19.2969C14.0654 18.8185 14.4504 18.4219 14.9404 18.4219H37.0604C37.5388 18.4219 37.9354 18.8185 37.9354 19.2969C37.9354 19.7752 37.5504 20.1719 37.0604 20.1719Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9404 20.0059C21.4621 20.0059 21.0654 19.6093 21.0654 19.1309V13.4609C21.0654 12.9826 21.4621 12.5859 21.9404 12.5859C22.4188 12.5859 22.8154 12.9826 22.8154 13.4609V19.1309C22.8154 19.6093 22.4188 20.0059 21.9404 20.0059Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0596 19.4809C29.5812 19.4809 29.1846 19.0843 29.1846 18.6059V13.4609C29.1846 12.9826 29.5812 12.5859 30.0596 12.5859C30.5379 12.5859 30.9346 12.9826 30.9346 13.4609V18.6059C30.9346 19.0959 30.5496 19.4809 30.0596 19.4809Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9383 32.1395C24.5183 32.1395 24.1217 32.0345 23.76 31.8361C22.9667 31.3695 22.5 30.4361 22.5 29.2578V26.4578C22.5 25.2795 22.9667 24.3345 23.7717 23.8678C24.5767 23.4011 25.6267 23.4711 26.6417 24.0661L29.0683 25.4661C30.0833 26.0495 30.6783 26.9245 30.6783 27.8578C30.6783 28.7911 30.0833 29.6661 29.0567 30.2495L26.63 31.6495C26.07 31.9761 25.4867 32.1395 24.9383 32.1395ZM24.95 25.3145C24.8333 25.3145 24.7283 25.3378 24.6467 25.3845C24.4017 25.5245 24.25 25.9211 24.25 26.4578V29.2578C24.25 29.7828 24.4017 30.1795 24.6467 30.3311C24.8917 30.4711 25.3117 30.4011 25.7667 30.1328L28.1933 28.7328C28.6483 28.4645 28.9283 28.1378 28.9283 27.8578C28.9283 27.5778 28.66 27.2511 28.1933 26.9828L25.7667 25.5828C25.4633 25.4078 25.1717 25.3145 24.95 25.3145Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10505_56299",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10505_56299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10505_56299",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsObjectiveGolive);
export default __webpack_public_path__ + "static/media/ads-objective-golive.26befb2e08deac6c601dd1ab5b6f3a43.svg";
export { ForwardRef as ReactComponent };